<template>
  <v-container grid-list-lg fill-height>
    <v-layout align-center justify-center>
      No ha sido posible cargar la información.
      Por favor, inténtelo más tarde.
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: 'Error'
}
</script>


// WEBPACK FOOTER //
// src/pages/Error.vue